import { type IAsyncExecStatusResult } from '@inpart-io/devtools-iap';
import { type GetterTree } from 'vuex';

import { type IImportStatusState } from './types';

export const GET_STATUS_RESULT = 'getStatusResult';

export const getters: GetterTree<IImportStatusState, unknown> = {
    [GET_STATUS_RESULT]: (_state) => {
        return (statusId: string): IAsyncExecStatusResult | undefined => {
            return _state.asyncTaskStatus.get(statusId);
        };
    }
};
